import { createSelector } from '@ngrx/store';
import * as fromFeature from '../reducers';
import * as userPasswordReducers from '../reducers/user-password.reducers';

export const getUserPasswordFeatureState = createSelector(
  fromFeature.getUserState,
  (state: fromFeature.UserState) => state.userPassword
);

export const getSecurityQuestions = createSelector(
  getUserPasswordFeatureState,
  userPasswordReducers.getSecurityQuestions
);
export const getChallengeQuestion = createSelector(
  getUserPasswordFeatureState,
  userPasswordReducers.getChallengeQuestion
);
export const getSetNewPasswordError = createSelector(
  getUserPasswordFeatureState,
  userPasswordReducers.getSetNewPasswordError
);
export const getChangePasswordLoading = createSelector(
  getUserPasswordFeatureState,
  userPasswordReducers.getChangePasswordLoading
);
export const getChangePasswordSuccess = createSelector(
  getUserPasswordFeatureState,
  userPasswordReducers.getChangePasswordSuccess
);
export const getChangePasswordFailure = createSelector(
  getUserPasswordFeatureState,
  userPasswordReducers.getChangePasswordFailure
);
export const getSetPasswordFailure = createSelector(
  getUserPasswordFeatureState,
  userPasswordReducers.getSetPasswordFailure
);
export const getValidationErrors = createSelector(
  getUserPasswordFeatureState,
  userPasswordReducers.getValidationErrors
);
